var v = /* @__PURE__ */ ((e) => (e.CONFIG = "config", e.EVENT = "event", e.USER = "user", e.SCREEN = "screen", e.START_TIME = "js", e))(v || {});
const f = {
  PK: "K-5A",
  K: "K-5A",
  1: "K-5A",
  2: "K-5A",
  3: "K-5A",
  4: "K-5A",
  5: "K-5A",
  6: "6-8A",
  7: "6-8A",
  8: "6-8A",
  9: "9-12A",
  10: "9-12A",
  11: "9-12A",
  12: "9-12A",
  U: "9-12A"
}, d = {
  a: "action",
  c: "component",
  f: "flavour",
  i: "interaction"
};
function a(...e) {
  window.dataLayer = window.dataLayer || [], window.dataLayer.push(arguments);
}
function s(e) {
  let n = {};
  for (const t of window.dataLayer)
    (t == null ? void 0 : t[0]) === e && (t != null && t[1]) && (n = t[1]);
  return n;
}
const l = (e) => {
  const n = {
    ...s(
      "user"
      /* USER */
    ),
    ...s(
      "screen"
      /* SCREEN */
    )
  }, t = e.arg, o = e.value || {};
  for (const c in o)
    d.hasOwnProperty(c) && (n[d[c]] = o[c]);
  a("event", `user_${t}`, n);
};
function _(e, n) {
  return l({
    arg: e,
    value: n
  });
}
function g(e) {
  return {
    user_id: e == null ? void 0 : e.id,
    role_id: e == null ? void 0 : e.role_id,
    school_id: e == null ? void 0 : e.school_id,
    grade_id: e == null ? void 0 : e.grade_id
  };
}
async function E({
  gaDestinationId: e = process.env.VITE_GA_DESTINATION_ID,
  user: n,
  config: t = {}
}) {
  if (!e)
    throw new Error("Google Analytics misconfigured");
  const o = document.createElement("script");
  o.async = !0, o.src = `https://www.googletagmanager.com/gtag/js?id=${e}`, o.onload = () => {
    const c = g(n);
    a("config", e, {
      cookie_flags: "secure;samesite=none",
      // let GA work inside iframes, like within CE
      ...c,
      ...t
    }), a("js", /* @__PURE__ */ new Date()), a("user", {
      ...c,
      flavour: (n == null ? void 0 : n.grade_name) && f[n == null ? void 0 : n.grade_name]
    });
  }, document.head.appendChild(o);
}
const A = (e) => a("screen", { ...e }), h = async (e) => {
  const n = g(e), t = s(
    "user"
    /* USER */
  );
  (n == null ? void 0 : n.user_id) !== (t == null ? void 0 : t.user_id) && a("user", {
    ...n,
    flavour: (e == null ? void 0 : e.grade_name) && f[e == null ? void 0 : e.grade_name]
  });
}, y = {
  mounted: (e, n) => {
    if (!n.arg || !n.value)
      return;
    const t = () => l(n);
    e.addEventListener(n.arg, t);
  }
}, p = {
  install: (e, n) => {
    n && n.beforeEach(({ path: t, meta: o }, c, r) => {
      const i = { path: t };
      o != null && o.screen && (i.screen = o.screen), A(i), r();
    }), e.directive("track", y);
  }
}, w = {
  inserted: (e, n) => {
    if (!n.arg || !n.value)
      return;
    const t = () => l(n);
    e.addEventListener(n.arg, t);
  }
}, T = {
  install: (e, n) => {
    n && n.beforeEach(({ path: t, meta: o }, c, r) => {
      const i = { path: t };
      o != null && o.screen && (i.screen = o.screen), A(i), r();
    }), e.directive("track", w);
  }
};
export {
  f as GRADE_FLAVOURS,
  d as TRACKING_ATTRIBUTES,
  v as TRACKING_KEYS,
  a as addTag,
  s as getLayerData,
  y as googleAnalyticsDirective,
  p as googleAnalyticsPlugin,
  w as googleAnalyticsVue2Directive,
  T as googleAnalyticsVue2Plugin,
  l as handleAnalyticsEvent,
  h as identifyGoogleAnalyticsUser,
  E as initializeGoogleAnalytics,
  A as setScreenContext,
  _ as trackEvent
};
